import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { validateGuid } from '../services/apiService';
import Button from '../components/Button';
import Container from '../components/Container';
import Content from '../components/Content';
import { Tab, Tabs } from 'react-bootstrap';
import { Row, Col, Card } from 'react-bootstrap';
import { getHeadersAPI } from '../api/ServicesConfiguration';

function ContractPortal() {
  const navigate = useNavigate();

  //Get URL Parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get('guid');
  const owner = queryParameters.get('owner');

  const [mainContracts, setMainContracts] = useState<any[]>([]);
  const [partnerContracts, setPartnerContracts] = useState<any[]>([]);
  const [businessType, setBusinessType] = useState<any>(0);

  if (!guid) {
    navigate('/ErrorPage');
  }

  // FetchData
  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      navigate('/ErrorPage');
    }
    let isAllContractsSigned: any = false;

    try {
      const responseBusinessType = await axios.get(
        process.env.REACT_APP_BASE_API_URL + '/getBusinessTypeByGuid/' + guid,
        {
          headers: await getHeadersAPI()
        }
      );

      setBusinessType(responseBusinessType.data.businessType);

      const response: any = await axios.get(
        process.env.REACT_APP_BASE_API_URL + '/getContractsByGuid/' + guid,
        {
          headers: await getHeadersAPI()
        }
      );

      if (response.data) {
        const contracts = response.data.filter(
          (c: any) => c.DocumentModel != 'Waiver'
        );

        const waiverByGuid = response.data.filter(
          (c: any) => c.Guid == guid && c.DocumentModel == 'Waiver'
        );

        if (
          contracts.filter((c: any) => !(c.SignatureStatus == 'SIGNED'))
            .length > 0
        ) {
          setMainContracts(
            contracts
              .filter((c: any) => c.Owner === 1)
              .sort((a: any, b: any) =>
                a.DocumentModel === 'Mantel'
                  ? -1
                  : b.DocumentModel === 'Mantel'
                  ? 1
                  : 0
              )
          );
          setPartnerContracts(
            contracts
              .filter((c: any) => c.Owner === 2)
              .sort((a: any, b: any) =>
                a.DocumentModel === 'Mantel'
                  ? -1
                  : b.DocumentModel === 'Mantel'
                  ? 1
                  : 0
              )
          );
        } else {
          await axios
            .post(
              process.env.REACT_APP_BASE_API_URL + '/allContractsSigned',
              { guid: guid },
              {
                headers: await getHeadersAPI()
              }
            )
            .then((response) => {
              isAllContractsSigned = true;
            })
            .catch((error) => {
              console.error('API Error:', error);
            });
        }

      

        //THIS WAVER GUID ?
        if (waiverByGuid.length > 0) {
          //NAVIGTE TO SIGN WAIVER
          navigate(`/ContractSignWaiver?guid=${guid}`);
        } else {
          if (isAllContractsSigned) {
            //REDIRECT TO CONTRACT SIGNED
            navigate('/ContractSigned');
          }
        }
      } else {
        navigate('/ErrorPage');
      }
    } catch (error) {
      navigate('/ErrorPage');
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      navigate('/ErrorPage');
    } else {
      fetchData();
    }
   
  }, []);

  function handleOnClick(
    smartDocumentContractId: number,
    guid: string,
    owner: number
  ) {
    navigate(
      '/ContractPreview?guid=' +
        guid +
        '&smartDocumentContractId=' +
        smartDocumentContractId +
        '&owner=' +
        owner
    );
  }

  return (
    <div>
      <Content className="mt-5">
        <Container>
          <Card className="p-5">
            <Tabs
              className="nav-pills mb-5"
              defaultActiveKey={
                owner
                  ? owner === '1'
                    ? 'main'
                    : owner === '2'
                    ? partnerContracts.length > 0
                      ? 'partner'
                      : 'main'
                    : 'main'
                  : 'main'
              }
              justify
            >
              <Tab
                eventKey={'main'}
                title={businessType === 1 ? 'Tekenbevoegde 1' : 'Aanvrager'}
              >
                <div style={{ textAlign: 'center' }}>
                  <div
                    className="mb-4"
                    style={{ fontSize: 30, fontWeight: 700 }}
                  >
                    Handtekening
                  </div>
                  <div className="mb-4">
                    {businessType === 1
                      ? 'Klik op de button hieronder om uw leasecontract te ondertekenen met iDIN. Ziet u twee buttons? Dan vragen wij u eerst de mantelovereenkomst separaat te ondertekenen en daarna het leasecontract.'
                      : 'Klik op de buttons hieronder om de standaardinformatie en uw contract te ondertekenen.'}
                  </div>
                  {mainContracts.map((c: any, i) => (
                    <div key={i + 1} className="mb-4">
                      <Button
                        className="btn-lg btn-success"
                        onClick={() =>
                          handleOnClick(c.SmartDocumentContractId, guid!, 1)
                        }
                        disabled={c.SignatureStatus == 'SIGNED'}
                      >
                        {c.DocumentModel === 'Mantel'
                          ? 'Lees & onderteken mantelovereenkomst'
                          : 'Lees & onderteken contract'}
                        {c.SignatureStatus == 'SIGNED' && (
                          <i className="ml-2 fas fa-check" />
                        )}
                      </Button>
                    </div>
                  ))}
                </div>
              </Tab>
              {partnerContracts.length > 0 ? (
                <Tab
                  eventKey={'partner'}
                  title={businessType === 1 ? 'Tekenbevoegde 2' : 'Partner'}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div
                      className="mb-4"
                      style={{ fontSize: 30, fontWeight: 700 }}
                    >
                      Handtekening
                    </div>
                    <div className="mb-4">
                      {businessType === 1
                        ? 'Klik op de button hieronder om uw leasecontract te ondertekenen met iDIN. Ziet u twee buttons? Dan vragen wij u eerst de mantelovereenkomst separaat te ondertekenen en daarna het leasecontract.'
                        : 'Klik op de buttons hieronder om de standaardinformatie en uw contract te ondertekenen.'}
                    </div>
                    {partnerContracts.map((c: any, i) => (
                      <div key={i + 2} className="mb-4">
                        <Button
                          className="btn-lg btn-success"
                          onClick={() =>
                            handleOnClick(c.SmartDocumentContractId, guid!, 2)
                          }
                          disabled={c.SignatureStatus == 'SIGNED'}
                        >
                          {c.DocumentModel === 'Mantel'
                            ? 'Lees & onderteken mantelovereenkomst'
                            : 'Lees & onderteken contract'}
                          {c.SignatureStatus == 'SIGNED' && (
                            <i className="ml-2 fas fa-check" />
                          )}
                        </Button>
                      </div>
                    ))}
                  </div>
                </Tab>
              ) : null}
            </Tabs>
            <Row>
              <Col>
                <img
                  src="../../dist/img/Refer_illustration.png"
                  className="float-right"
                  style={{ width: 285 }}
                />
              </Col>
            </Row>
          </Card>
        </Container>
      </Content>
    </div>
  );
}

export default ContractPortal;
